export const UI_CHANGE_LANGUAGE = "[UI] Change language";
export const OPEN_MOBILE_MENU = "[UI] Open mobile menu";
export const CLOSE_MOBILE_MENU = "[UI] Close mobile menu";



// WEBPACK FOOTER //
// ./src/app/ui/store/types.js